export default "__VITE_ASSET__oHgXVttu__"